import { render, staticRenderFns } from "./SessionListItem.vue?vue&type=template&id=2e44b5e0&scoped=true"
import script from "./SessionListItem.vue?vue&type=script&lang=js"
export * from "./SessionListItem.vue?vue&type=script&lang=js"
import style0 from "./SessionListItem.vue?vue&type=style&index=0&id=2e44b5e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e44b5e0",
  null
  
)

export default component.exports